<template>
	<v-container>
		<v-form ref="form" v-model="valid">
			<auto-complete-entity
				ref="itemId"
				v-model="value.itemId"
				entityApi="item"
				:itemPreSelected="selectedItem"
				itemText="description"
				itemValue="id"
				:label="$t('entities.jobStageItemProd.props.itemId')"
				:clearable="true"
				:rules="$isRequiredRule"
			/>

			<auto-complete-entity
				ref="unitId"
				v-model="value.unitId"
				entityApi="unit"
				fieldApi="description"
				itemText="description"
				itemValue="id"
				:itemPreSelected="selectedUnit"
				:label="$t('entities.stageItem.props.unitId')"
				:clearable="true"
				:rules="this.value.itemId ? [] : $isRequiredRule"
			/>
			<v-text-field
				v-if="selectedItem && selectedItem.type == 'Parameter'"
				:label="$t('entities.stageItem.props.qtMin')"
				type="number"
				v-model="value.qtMin"
			></v-text-field>
			<v-text-field
				v-if="selectedItem && selectedItem.type == 'Parameter'"
				:label="$t('entities.stageItem.props.qtMax')"
				type="number"
				v-model="value.qtMax"
			></v-text-field>
			<v-text-field
				:label="$t('entities.jobStageItemProd.props.qtEstimated')"
				v-model="value.qtEstimated"
				type="text"
			></v-text-field>
			<v-text-field
				:label="$t('entities.jobStageItemProd.props.qtReal')"
				v-model="value.qtReal"
				type="number"
			></v-text-field>
			<v-text-field
				:label="$t('entities.stageItem.props.itemDescription')"
				v-model="value.itemDescription"
				clearable
			></v-text-field>
		</v-form>
	</v-container>
</template>

<script>
	export default {
		components: {},
		props: {
			value: {
				default() {
					return {
						qtEstimated: 0,
						qtdReal: 0,
						itemId: null,
					};
				},
			},
		},
		data() {
			return {
				valid: true,
				selectedItem: null,
				selectedUnit: null,
			};
		},
		watch: {
			async "value.itemId"() {
				this.selectedUnit = null;
				this.selectedItem = null;
				await this.getUnitial();
				this.setUnitId();
			},
		},
		methods: {
			setUnitId() {
				if (this.selectedItem && this.selectedItem.unitId)
					this.value.unitId = this.selectedItem.unitId;
			},
			isValid() {
				let formValid = this.$refs.form.validate();
				let itemIdValid = this.value.itemDescription
					? true
					: this.$refs.itemId.isValid();
				let unitIdValid = this.value.itemDescription
					? this.$refs.unitId.isValid()
					: true;

				return formValid && itemIdValid && unitIdValid;
			},
			async getItemById(id) {
				let res = await this.$http.get(`item/s-id?id=${id}`);
				if (res.success) this.selectedItem = res.data;
			},
			selectItem(value) {
				this.$emit("select", value);
				this.value.itemId = value.id;
			},
			async getItem() {
				this.loadingItem = true;
				if (this.value.itemId) {
					let res = await this.$http.get(`item/s-id?id=${this.value.itemId}`);
					if (res.success) if (res.data) this.selectedItem = res.data;
				}
				this.loadingItem = false;
			},
			async getUnit() {
				this.loadingItem = true;
				if (this.value.unitId) {
					let res = await this.$http.get(`unit/s-id?id=${this.value.unitId}`);
					if (res.success) if (res.data) this.selectedUnit = res.data;
				}
				this.loadingItem = false;
			},
			async getUnitial() {
				await this.getUnit();
				await this.getItem();
			},
		},
		async mounted() {
			this.selectedUnit = null;
			this.selectedItem = null;
			await this.getUnitial();
		},
	};
</script>
